import * as XLSX from "xlsx";
import {
  MonthlyOverviewDetailsResponse,
  MonthlyOverviewResponse,
} from "../../types/monthlyOverview.type";
import {
  METRIC_COLUMNS,
  METRIC_TITLES,
  METRIC_VALUE_FIELD,
} from "./monthlyOverview.columns";

/** Подпись периода для имени файла, напр. "06-2026". */
export const monthLabel = (month: number, year: number) =>
  `${String(month).padStart(2, "0")}-${year}`;

// Excel-имя листа: не длиннее 31 символа и без запрещённых символов.
const safeSheetName = (name: string) =>
  name.replace(/[\\/?*[\]:]/g, " ").substring(0, 31);

/** Добавляет в книгу лист с расшифровкой одной метрики (с итоговой строкой). */
function appendDetailsSheet(
  wb: XLSX.WorkBook,
  details: MonthlyOverviewDetailsResponse
) {
  const cols = METRIC_COLUMNS[details.metric];
  const valueIdx = cols.findIndex(
    (c) => c.key === METRIC_VALUE_FIELD[details.metric]
  );

  const header = cols.map((c) => c.title);
  const body = details.rows.map((row) =>
    cols.map((c) => {
      const value = (row as any)[c.key];
      return value === undefined || value === null ? "" : value;
    })
  );
  const totalRow = cols.map((_, i) => {
    if (i === 0) return "ИТОГО";
    if (i === valueIdx) return details.total;
    return "";
  });

  const aoa = [header, ...body, [], totalRow];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = cols.map((c) => ({
    wch: Math.max(c.title.length + 2, 16),
  }));

  XLSX.utils.book_append_sheet(wb, ws, safeSheetName(METRIC_TITLES[details.metric]));
}

/** Экспорт расшифровки одной метрики (один лист). */
export function exportMetricDetails(details: MonthlyOverviewDetailsResponse) {
  const wb = XLSX.utils.book_new();
  appendDetailsSheet(wb, details);
  XLSX.writeFile(
    wb,
    `Обзор_${METRIC_TITLES[details.metric]}_${monthLabel(details.month, details.year)}.xlsx`
  );
}

/**
 * Экспорт всего обзора: лист «Обзор» со сводкой + по листу на каждую метрику
 * с полной расшифровкой.
 */
export function exportFullOverview(
  overview: MonthlyOverviewResponse,
  detailsList: MonthlyOverviewDetailsResponse[]
) {
  const wb = XLSX.utils.book_new();

  const summaryAoa: Array<Array<string | number>> = [
    ["Обзор месяца", monthLabel(overview.month, overview.year)],
    [],
    ["Показатель", "Сумма, UZS"],
    ["Получено от клиентов", overview.metrics.receivedFromClients],
    ["Произведено товаров", overview.metrics.producedGoods],
    ["Продажи", overview.metrics.sales],
  ];
  const summaryWs = XLSX.utils.aoa_to_sheet(summaryAoa);
  summaryWs["!cols"] = [{ wch: 28 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, summaryWs, "Обзор");

  detailsList.forEach((details) => appendDetailsSheet(wb, details));

  XLSX.writeFile(
    wb,
    `Обзор_месяца_${monthLabel(overview.month, overview.year)}.xlsx`
  );
}
